import WPStagingCommon from '../../wpstg.js';
import 'regenerator-runtime/runtime';
import WPStagingBackup from './wpstg-backup';

let WPStagingBackupRestore;

(function($) {
  window.addEventListener('backups-tab', function() {
    WPStagingBackupRestore.listen();
  });

  WPStagingBackupRestore = {
    listen() {
      $('body')
          .off('click', '.wpstg--backup--restore', WPStagingBackupRestore.clickedRestore)
          .on('click', '.wpstg--backup--restore', WPStagingBackupRestore.clickedRestore);
    },
    clickedRestore(e) {
      WPStagingCommon.resetErrors();
      e.preventDefault();
      WPStagingBackup.isCancelled = false;

      WPStagingBackup.modal.import.data.file = this.getAttribute('data-filePath');
      WPStagingBackupRestore.selectedBackup();
    },
    selectedBackup() {
      WPStagingCommon.ajax(
          {
            action: 'wpstg--backups--read-backup-metadata',
            accessToken: wpstg.accessToken,
            nonce: wpstg.nonce,
            wpstg: {
              file: WPStagingBackup.modal.import.data.file,
            },
          },
          function(response) {
            let responseData;

            try {
              responseData = JSON.parse(WPStagingCommon.getDataFromWordPressResponse(response));
              // Get the first item of the blogs object:
              // blogs {1: {someData}} => {someData}
              const mainNetwork = responseData.networks[Object.keys(responseData.networks)[0]];
              const mainBlog = mainNetwork.blogs[Object.keys(mainNetwork.blogs)[0]];
              responseData = mainBlog;
            } catch (e) {
              WPStagingCommon.showError(e);
            }

            WPStagingBackup.modal.import.data.backupMetadata = responseData;

            const postData = new FormData();
            postData.append('action', 'wpstg--backups--import--file-info');
            postData.append('accessToken', wpstg.accessToken);
            postData.append('nonce', wpstg.nonce);
            postData.append('filePath', WPStagingBackup.modal.import.data.file);

            fetch(ajaxurl, {
              method: 'POST',
              body: postData,
            })
                .then(WPStagingCommon.handleFetchErrors)
                .then((res) => res.json())
                .then((html) => {
                  WPStagingBackupRestore.importModal(html, postData);
                })
                .catch((e) => WPStagingCommon.showAjaxFatalError(e, '', 'Submit an error report.'));

            $('.wpstg--modal--actions .wpstg--swal2-confirm').show();
            $('.wpstg--modal--actions .wpstg--swal2-confirm').prop('disabled', false);
          },
      );
    },
    importModal(confirmHtml) {
      const importSiteBackup = (data) => {
        WPStagingCommon.resetErrors();

        if (WPStagingBackup.isCancelled) {
          // console.log('cancelled');
          WPStagingBackup.statusStop();
          return;
        }

        WPStagingBackup.timer.start();

        window.addEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);

        WPStagingCommon.ajax(
            {
              action: 'wpstg--backups--import',
              accessToken: wpstg.accessToken,
              nonce: wpstg.nonce,
            },
            function(response) {
              if (WPStagingBackup.isCancelled) {
                return;
              }

              if (typeof response === 'undefined') {
                setTimeout(function() {
                  importSiteBackup(data);
                }, wpstg.delayReq);
                return;
              }

              WPStagingBackup.processResponse(response);
              if (!WPStagingBackup.processInfo.interval) {
                WPStagingBackup.statusStart('restore');
              }

              if (response.status === false) {
                importSiteBackup(data);
              } else if (response.status === true) {
                window.removeEventListener('beforeunload', WPStaging.warnIfClosingDuringProcess);
                $('#wpstg--progress--status').text('Backup successfully imported!');
                if (WPStagingBackup.messages.shouldWarn()) {
                  WPStagingBackup.logsModal();
                  return;
                }
                WPStagingBackup.statusStop();
                const logEntries = $('.wpstg--modal--process--logs').get(1).innerHTML;
                const html = '<div class="wpstg--modal--process--logs">' + logEntries + '</div>';
                const issueFound = html.includes('wpstg--modal--process--msg--warning') || html.includes('wpstg--modal--process--msg--error') ? 'Issues(s) found!<br> ' : '';

                const loginText = WPStagingBackup.modal.import.data.backupMetadata.isExportingDatabase ? 'You will be redirected to the login page after closing this modal.' : '';

                // TODO: remove default classes.
                WPStagingCommon.getSwalModal(true, {
                  container: 'wpstg-restore-finished-container',
                }).fire({
                  icon: 'success',
                  title: 'Finished Successfully',
                  html: '<div id="wpstg-restore-success" class="wpstg--grey">Site has been restored from backup. ' + loginText + '  <br/><br/><span class="wpstg--modal--process--msg-found">' + issueFound + '</span><button class="wpstg--modal--process--logs--tail" data-txt-bad="">Show Logs</button></div><br/>' + html,
                  onClose: function() {
                    if (WPStagingBackup.modal.import.data.backupMetadata.isExportingDatabase) {
                      document.getElementById('wpstg-restore-wait').style.display = 'flex';

                      // Reload in 15 seconds if something goes wrong with the Ajax call.
                      setTimeout(function() {
                        document.location.reload(true);
                      }, 15000);

                      WPStagingCommon.ajax(
                          {
                            action: 'raw_wpstg--backups--login-url',
                            accessToken: wpstg.accessToken,
                            nonce: wpstg.nonce,
                          },
                          function(response) {
                            const loginUrl = new URL(response.data.loginUrl);
                            loginUrl.searchParams.set('accessToken', wpstg.accessToken);
                            loginUrl.searchParams.set('wpstgAfterImport', 'yes');
                            window.location.href = loginUrl.toString();
                          },
                      );
                    } else {
                      WPStagingBackup.fetchListing();
                    }
                  },
                },
                );
              } else {
                setTimeout(function() {
                  importSiteBackup(data);
                }, wpstg.delayReq);
              }
            },
            'json',
            false,
            10, // Don't retry upon failure
            1.25,
        );
      };

      const $modal = $('#wpstg--modal--backup--import');

      WPStagingBackup.modal.import.html = $modal.html();
      WPStagingBackup.modal.import.baseDirectory = $modal.attr('data-baseDirectory');
      WPStagingBackup.modal.import.btnTxtNext = $modal.attr('data-nextButtonText');
      WPStagingBackup.modal.import.btnTxtConfirm = $modal.attr('data-confirmButtonText');
      WPStagingBackup.modal.import.btnTxtCancel = $modal.attr('data-cancelButtonText');

      WPStagingCommon.getSwalModal()
          .mixin({
            progressSteps: ['1', '2'],
          })
          .queue([
            {
              html: $('.wpstg--modal--backup--import--introduction').first(),
              confirmButtonText: 'Next',
              showCancelButton: true,
              showConfirmButton: true,
              reverseButtons: true,
              width: 600,
              onRender() {
                $('.wpstg--modal--backup--import--introduction .wpstg-backup-restore-contains-database').hide();
                $('.wpstg--modal--backup--import--introduction .wpstg-backup-restore-contains-database-multisite').hide();
                $('.wpstg--modal--backup--import--introduction .wpstg-backup-restore-contains-files').hide();

                if (WPStagingBackup.modal.import.data.backupMetadata.isExportingDatabase) {
                  $('.wpstg--modal--backup--import--introduction .wpstg-backup-restore-contains-database').show();
                }

                console.log(WPStagingBackup.modal.import.data.backupMetadata);
                if (WPStagingBackup.modal.import.data.backupMetadata.isExportingDatabase && WPStagingBackup.modal.import.data.backupMetadata.singleOrMulti === 'multi') {
                  $('.wpstg--modal--backup--import--introduction .wpstg-backup-restore-contains-database-multisite').show();
                }

                if (
                  WPStagingBackup.modal.import.data.backupMetadata.isExportingMuPlugins ||
                  WPStagingBackup.modal.import.data.backupMetadata.isExportingPlugins ||
                  WPStagingBackup.modal.import.data.backupMetadata.isExportingThemes ||
                  WPStagingBackup.modal.import.data.backupMetadata.isExportingUploads ||
                  WPStagingBackup.modal.import.data.backupMetadata.isExportingOtherWpContentFiles
                ) {
                  $('.wpstg--modal--backup--import--introduction .wpstg-backup-restore-contains-files').show();
                }
              },
            },
            {
              html: confirmHtml,
              confirmButtonText: 'Restore',
              showCancelButton: true,
              showConfirmButton: true,
              reverseButtons: true,
              width: 650,
            },
          ])
          .then((res) => {
            // Early bail: Dismissed, canceled, or in a incoherent state.
            if (!res || !res.value) {
              return;
            }

            // Early bail: Step 1 (Confirm) must be true.
            if (!res.value[1] || res.value[1] !== true) {
              return;
            }

            WPStagingBackup.isCancelled = false;

            const data = WPStagingBackup.modal.import.data;

            // Unset fileObject as we don't need it anymore, and it can't be converted to array.
            WPStagingBackup.modal.import.data.fileObject = null;

            data['file'] = WPStagingBackup.modal.import.baseDirectory + data['file'];

            WPStagingCommon.ajax(
                {
                  action: 'wpstg--backups--prepare-import',
                  accessToken: wpstg.accessToken,
                  nonce: wpstg.nonce,
                  wpstgImportData: data,
                },
                function(response) {
                  if (response.success) {
                    WPStagingBackup.process({
                      execute: () => {
                        WPStagingBackup.messages.reset();
                        importSiteBackup(data);
                      },
                    });
                  } else {
                    WPStagingCommon.showAjaxFatalError(response.data, '', 'Submit an error report.');
                  }
                },
                'json',
                false,
                10,
                1.25,
                function(xhr, textStatus, errorThrown) {
                  if (xhr.status === 423) {
                    WPStagingCommon.continueErrorHandle = false;
                    WPStagingBackup.shouldCleanUp = false;
                    WPStagingCommon.closeSwalModal();

                    setTimeout(function() {
                      WPStagingBackup.shouldCleanUp = true;
                    }, 1000);
                    WPStagingCommon.showErrorModal(xhr.responseJSON.data);
                  } else {
                    WPStagingCommon.continueErrorHandle = true;
                  }
                },
            );
          });
    },
  };
}(jQuery));

export default WPStagingBackupRestore;
